import { useCallback, useEffect, useState } from 'react';
import { rankingManager } from '../services/rankingManager';

interface UseRankingsProps {
  apiBaseUrl: string;
}

/**
 * 랭킹 관리 훅 (싱글톤 기반)
 */
export const useRankings = ({ apiBaseUrl }: UseRankingsProps) => {
  const [state, setState] = useState(() => {
    const initialState = rankingManager.getState();
    return initialState;
  });

  // API Base URL 설정
  useEffect(() => {
    if (apiBaseUrl) {
      rankingManager.setApiBaseUrl(apiBaseUrl);
    }
  }, [apiBaseUrl]);

  // 랭킹 매니저 상태 변경 구독
  useEffect(() => {
    const unsubscribe = rankingManager.subscribe(() => {
      const newState = rankingManager.getState();
      setState(newState);
    });

    // 초기 상태도 한 번 확인하고, 이미 데이터가 있으면 상태 업데이트
    const currentState = rankingManager.getState();
    if (currentState.rankings.length > 0) {
      setState(currentState);
    }

    return () => {
      unsubscribe();
    };
  }, []); // 마운트 시 한 번만 실행

  // 안정된 함수 참조 제공
  const loadRankings = useCallback(() => {
    if (apiBaseUrl && !rankingManager.getApiBaseUrl()) {
      rankingManager.setApiBaseUrl(apiBaseUrl);
    }
    return rankingManager.loadRankings();
  }, [apiBaseUrl]);

  const refreshRankings = useCallback(() => {
    if (apiBaseUrl && !rankingManager.getApiBaseUrl()) {
      rankingManager.setApiBaseUrl(apiBaseUrl);
    }
    return rankingManager.refreshRankings();
  }, [apiBaseUrl]);

  const changePage = useCallback(
    (page: number) => {
      if (apiBaseUrl && !rankingManager.getApiBaseUrl()) {
        rankingManager.setApiBaseUrl(apiBaseUrl);
      }
      return rankingManager.changePage(page);
    },
    [apiBaseUrl]
  );

  return {
    rankings: state.rankings,
    isRankingLoading: state.isLoading,
    rankingError: state.error,
    currentPage: state.currentPage,
    totalPages: state.totalPages,
    rankingsAsOf: (state as any).rankingsAsOf as string | null,
    loadRankings,
    refreshRankings,
    changePage,
  };
};
